/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DR` - Draft
* `PE` - Pending Approval
* `AC` - Active
* `FULFILLED` - Fulfilled
* `RE` - Rejected
* `VO` - Void
 */
export type OrderState = typeof OrderState[keyof typeof OrderState];


export const OrderState = {
  DR: 'DR',
  PE: 'PE',
  AC: 'AC',
  FULFILLED: 'FULFILLED',
  RE: 'RE',
  VO: 'VO',
} as const;
